import { BudgetWorkspace } from "@/components/academy/BudgetWorkspace";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Wallet } from "lucide-react";

export default function SquadBudget({squad="",academyId=""}) {
  if (academyId && academyId !== "__unaffiliated__") return <div className="p-5 sm:p-8"><BudgetWorkspace key={`${academyId}:${squad}`} academyId={academyId} teamName={squad}/></div>;
  return <PersonalSquadBudget squad={squad} academyId={academyId}/>;
}

function PersonalSquadBudget({squad="",academyId=""}) {
  const [d, setD] = useState(null),[error,setError]=useState("");
  const navigate = useNavigate();
  useEffect(() => { api.get(`/squad/budget?${new URLSearchParams({squad,academy_id:academyId})}`).then((r) => {setD(r.data);setError("");}).catch(e=>setError(typeof e.response?.data?.detail==='string' ? e.response.data.detail : 'Team budget could not be loaded.')); }, [squad,academyId]);
  if (!d) return <div data-testid="team-budget-status" role={error ? "alert" : "status"} className="p-8 text-sm text-muted-foreground">{error || 'Loading team budget…'}</div>;
  return (
    <div>
      <header className="h-16 border-b border-border flex items-center px-8 gap-4 sticky top-0 bg-background z-10">
        <h1 className="font-heading text-xl font-black tracking-tight">Team Budget</h1>
      </header>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-px bg-border border-b border-border">
        <div className="p-6 bg-background"><div className="text-xs tracking-[0.2em] uppercase font-bold text-muted-foreground flex items-center gap-2"><Wallet className="w-4 h-4" /> Grand Total</div><div className="font-heading text-4xl font-black tabular-nums mt-2">₹{d.grand_total.toLocaleString()}</div></div>
        {Object.entries(d.by_category).slice(0, 4).map(([c, v]) => (
          <div key={c} className="p-6 bg-background"><div className="text-xs tracking-[0.2em] uppercase font-bold text-muted-foreground">{c}</div><div className="font-heading text-2xl font-black tabular-nums mt-2">₹{v.toLocaleString()}</div></div>
        ))}
      </div>
      <div className="p-8">
        <div className="border border-border" data-testid="squad-budget-list">
          <table className="w-full text-sm">
            <thead><tr className="border-b border-border text-xs tracking-[0.15em] uppercase font-bold text-muted-foreground"><th className="text-left p-3">Athlete</th><th className="text-right p-3">Items</th><th className="text-right p-3">Total</th></tr></thead>
            <tbody>
              {d.rows.map((r) => (
                <tr key={r.athlete_id} className="border-b border-border last:border-0 cursor-pointer hover:bg-surface" onClick={() => navigate(`/athlete/${r.athlete_id}?tab=budget`)} data-testid={`squad-budget-${r.athlete_id}`}>
                  <td className="p-3 font-medium">{r.name}</td><td className="p-3 text-right tabular-nums text-muted-foreground">{r.items}</td><td className="p-3 text-right font-heading font-bold tabular-nums">₹{r.total.toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
